"use strict";
import _ from "underscore";
var paymentAddressIntegrationValidator = function(accountSettings) {
  var nullValidator = function(_value, _errorReceiver) {
    return { valid: true };
  };
  var fieldLengthValidator = function(length, value, errorReceiver) {
    var validationResult = {
      valid: (value && value.length || 0) <= length
    };
    if (!validationResult.valid) {
      validationResult.errorMessage = "has a maximum length of " + length + " characters (" + value.length + " entered)";
    }
    return validationResult;
  };
  var validatorForField = function(name) {
    var expectedLength = lengthValidations[name];
    return expectedLength ? _.partial(fieldLengthValidator, expectedLength) : nullValidator;
  };
  var lengthValidations = (function() {
    if (accountSettings && accountSettings.integration_validations && accountSettings.integration_validations.payment_address && accountSettings.integration_validations.payment_address.max_length) {
      return accountSettings.integration_validations.payment_address.max_length;
    } else {
      return {};
    }
  })();
  return {
    validate: function(name, value, errorReceiver) {
      return validatorForField(name)(value, errorReceiver);
    }
  };
};
export default paymentAddressIntegrationValidator;
